var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disabled-comment text-center"},[_vm._v("\n  Please\n  "),_c('a',{attrs:{"href":_vm.registerLink}},[_vm._v("register")]),_vm._v("\n  or\n  "),_c('a',{attrs:{"href":_vm.signInLink}},[_vm._v("sign in")]),_vm._v("\n  to reply\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f23423e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_signed_out_widget.vue
// module id = null
// module chunks = 